import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  style: {"width":"100%"},
  class: "table-com"
}
const _hoisted_2 = {
  key: 0,
  class: "inlineBlock"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "sort-icon"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 3,
  class: "add-info"
}
const _hoisted_7 = { class: "add-sub" }
const _hoisted_8 = ["onClick", "src"]
const _hoisted_9 = ["src", "onClick"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 4 }
const _hoisted_12 = {
  class: /*@__PURE__*/_normalizeClass({ span: true })
}
const _hoisted_13 = { key: 9 }
const _hoisted_14 = { class: "multi-text" }
const _hoisted_15 = {
  key: 11,
  class: "table-icon"
}
const _hoisted_16 = { class: "multi-text" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 12 }
const _hoisted_19 = {
  key: 0,
  class: "order-status",
  style: {"font-weight":"500"}
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 13 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 14 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 15,
  style: {"font-weight":"500"}
}
const _hoisted_30 = { key: 16 }
const _hoisted_31 = { key: 17 }
const _hoisted_32 = {
  key: 18,
  class: "special-tip"
}
const _hoisted_33 = { class: "special" }
const _hoisted_34 = {
  key: 0,
  class: "tip"
}
const _hoisted_35 = ["data-textSelect", "innerHTML"]
const _hoisted_36 = {
  key: 23,
  class: "button-fixed"
}
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "tips-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_tips_dialog = _resolveComponent("tips-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "draggableTable",
        class: "table-row-hover",
        "header-cell-style": { background: '#fafafa', color: '#0F1423' },
        "row-class-name": _ctx.stripe ? _ctx.tableRowClassName : '',
        stripe: _ctx.stripe,
        data: _ctx.list,
        style: {"width":"100%"},
        height: _ctx.height,
        onRowClick: _ctx.rowClick,
        "cell-class-name": _ctx.isClick ? _ctx.tableCellClassName : ''
      }, {
        empty: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.noData,
            alt: "",
            style: {"width":"309px","height":"112px","margin-bottom":"-30px"}
          }, null, 8, _hoisted_37),
          _cache[4] || (_cache[4] = _createElementVNode("div", null, "暂无数据", -1))
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tHeaderList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              fixed: item.fixed ? item.fixed : item.fixed,
              key: index,
              prop: item.prop,
              label: item.label,
              width: item.width,
              align: item.align ?? 'center',
              "show-overflow-tooltip": "",
              class: _normalizeClass(item.class),
              style: _normalizeStyle({ display: item.hide ? 'none' : '' })
            }, {
              header: _withCtx(() => [
                (item.type === 'selection')
                  ? (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: 0,
                      modelValue: _ctx.checkAll,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkAll) = $event)),
                      onChange: _ctx.handleCheckAllChange
                    }, null, 8, ["modelValue", "onChange"]))
                  : _createCommentVNode("", true),
                (item.label)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass({ tHStyle: true, textR: item.type === 'selection' })
                    }, _toDisplayString(item.label), 3))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx((scope) => [
                (item.type === 'index')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.getNumber(scope.$index + 1)), 1))
                  : _createCommentVNode("", true),
                (item.type === 'selection')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: scope.row[item.prop],
                        "onUpdate:modelValue": ($event: any) => ((scope.row[item.prop]) = $event),
                        class: "fixed-left",
                        disabled: 
                item.disableByCheckbox && scope.row[item.disableByCheckbox]
              ,
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                        onChange: ($event: any) => (_ctx.changeCheckbox(scope.row))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'sort')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["index-sel", { hide: !scope.row['selectStatus'] }])
                      }, _toDisplayString(scope.row["indexSel"]), 3),
                      _createElementVNode("img", {
                        style: _normalizeStyle({
                width: `${item.iconWidth}px`,
                height: `${item.iconHeight}px`,
              }),
                        src: _ctx.sort,
                        alt: ""
                      }, null, 12, _hoisted_5)
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'addSub')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          onClick: _withModifiers(($event: any) => (
                  _ctx.handleCommand(scope.$index, scope.row, item.btnTypeSub)
                ), ["stop"]),
                          src: _ctx.sub,
                          style: _normalizeStyle([{"cursor":"pointer"}, {
                  width: `${item.iconWidth}px`,
                  height: `${item.iconHeight}px`,
                }]),
                          alt: ""
                        }, null, 12, _hoisted_8),
                        _createVNode(_component_el_input, {
                          class: "input",
                          onInput: ($event: any) => (
                  _ctx.handleCommand(scope.$index, scope.row, item.btnTypeInput),
                    (scope.row[item.prop] = String(scope.row[item.prop])
                      .replace(/[^\d]/g, '')
                      .replace(/0*(\d+)/, '$1'))
                ),
                          size: "small",
                          modelValue: scope.row[item.prop],
                          "onUpdate:modelValue": ($event: any) => ((scope.row[item.prop]) = $event),
                          placeholder: ""
                        }, null, 8, ["onInput", "modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("img", {
                          src: _ctx.add,
                          onClick: _withModifiers(($event: any) => (
                  _ctx.handleCommand(scope.$index, scope.row, item.btnTypeAdd)
                ), ["stop"]),
                          style: _normalizeStyle([{"cursor":"pointer"}, {
                  width: `${item.iconWidth}px`,
                  height: `${item.iconHeight}px`,
                }]),
                          alt: ""
                        }, null, 12, _hoisted_9)
                      ]),
                      _createElementVNode("div", {
                        innerHTML: 
                _ctx.brokenComputed(scope.row[item.prop], scope.row.selectStatus)
              ,
                        class: "info"
                      }, null, 8, _hoisted_10)
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'editInput')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _withDirectives(_createVNode(_component_el_input, {
                        size: "small",
                        modelValue: scope.row[item.prop],
                        "onUpdate:modelValue": ($event: any) => ((scope.row[item.prop]) = $event),
                        modelModifiers: { trim: true },
                        onBlur: ($event: any) => (_ctx.handleCommand(scope.$index, scope.row, item.btnType))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]), [
                        [_vShow, item.editStatus]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'twoLines')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: _normalizeClass(["two-lines table-icon", item.class])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.propList, (items, inde) => {
                        return (_openBlock(), _createElementBlock("span", { key: inde }, [
                          (items.prop === 'incomeBalanceDisplay')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(_ctx.renderColor(scope.row[items.prop]))
                              }, _toDisplayString(scope.row[items.prop]), 3))
                            : (items.prop === 'incomePercentDisplay')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: _normalizeClass(_ctx.renderColor(scope.row['incomeBalanceDisplay']))
                                }, _toDisplayString(scope.row[items.prop]), 3))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  class: _normalizeClass(items.class)
                                }, _toDisplayString(scope.row[items.prop]), 3)),
                          (scope.row[items.icon])
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                class: _normalizeClass({
                    span: true,
                    'us-span': scope.row[items.icon] === 'US',
                  })
                              }, _toDisplayString(scope.row[items.icon]), 3))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true),
                (item.type === 'twoLinesIconS')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      class: _normalizeClass(["two-lines-icons", item.class])
                    }, [
                      _createElementVNode("p", {
                        class: _normalizeClass(item.propList[0].class)
                      }, _toDisplayString(scope.row[item.propList[0].prop]), 3),
                      _createElementVNode("p", {
                        class: _normalizeClass(item.propList[1].class)
                      }, _toDisplayString(scope.row[item.propList[1].prop]), 3),
                      _createElementVNode("p", {
                        class: _normalizeClass(item.propList[2].class),
                        style: _normalizeStyle({
                  'background-color': _ctx.getColor(
                    scope.row[item.propList[2].prop]
                  ),
                })
                      }, _toDisplayString(scope.row[item.propList[2].prop]), 7)
                    ], 2))
                  : _createCommentVNode("", true),
                (item.type === 'twoLinesTab')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 7 }, _renderList(item.propList, (items, inF) => {
                      return (_openBlock(), _createElementBlock("div", { key: inF }, [
                        _createElementVNode("div", null, _toDisplayString(scope.row[items]), 1)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true),
                (item.type === 'icon')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                      _createElementVNode("span", null, _toDisplayString(scope.row[item.prop]), 1),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(scope.row[item.icon]), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (item.type === 'button')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_el_button, {
                        onClick: _withModifiers(($event: any) => (_ctx.handleCommand(scope.$index, scope.row, item.btnType)), ["stop"]),
                        class: _normalizeClass({ btnText: true }),
                        disabled: item.disabled,
                        type: item.color || '',
                        size: item.size
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode(" 按钮 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick", "disabled", "type", "size"])
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'multiText')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 10 }, _renderList(item.propList, (itemL, idx) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "table-icon",
                        key: idx
                      }, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(scope.row[item.prop]), 1),
                        (itemL.icon)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass({
                  span: true,
                  'us-span': scope.row[item.icon] === 'US',
                })
                            }, _toDisplayString(scope.row[item.icon]), 3))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true),
                (item.type === 'nameCn')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.propList, (itemN, idx) => {
                        return (_openBlock(), _createElementBlock("span", { key: idx }, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(scope.row[itemN.prop]), 1),
                          (item === 'nameCn')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "/"))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'status')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (scope.row[item.prop])
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.STATES[scope.row[item.prop]]), 1),
                            (scope.row.cancelOrderText)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.clickCancelOrderIcon(scope.row))
                                }, null, 8, _hoisted_20))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_21, " 下单失败 "))
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'orderAction')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (!scope.row[item.prop] || scope.row[item.prop] === 9)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            style: {"cursor":"pointer"},
                            class: "success",
                            onClick: _withModifiers(($event: any) => (_ctx.handleCommand(scope.$index, scope.row, 'reorder')), ["stop"])
                          }, "重新下单", 8, _hoisted_23))
                        : _createCommentVNode("", true),
                      (_ctx.ORDER_CANCEL.includes(scope.row[item.prop]))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            style: {"cursor":"pointer"},
                            class: "success",
                            onClick: _withModifiers(($event: any) => (_ctx.handleCommand(scope.$index, scope.row, item.btnType)), ["stop"])
                          }, " 撤单 ", 8, _hoisted_24))
                        : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.STATES[scope.row[item.prop]]), 1))
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'state')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (scope.row[item.prop] === 3)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "success",
                            onClick: _withModifiers(($event: any) => (_ctx.handleCommand(scope.$index, scope.row, item.btnType)), ["stop"])
                          }, _toDisplayString(_ctx.LPOASTATE[scope.row[item.prop]]), 9, _hoisted_27))
                        : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.LPOASTATE[scope.row[item.prop]]), 1))
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'entrustProp')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.ENTRUSTPROPMAP[scope.row[item.prop]]), 1))
                  : _createCommentVNode("", true),
                (item.type === 'time')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.dayjs(scope.row[item.prop]).format("HH:mm")), 1))
                  : _createCommentVNode("", true),
                (item.type === 'date')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.dayjs(scope.row[item.prop]).format("YYYY/MM/DD HH:mm:ss")), 1))
                  : _createCommentVNode("", true),
                (item.type === 'specialTip')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, _toDisplayString(scope.row[item.prop]), 1),
                      (_ctx.buyFlag(scope.row))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "购买力不足"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!item.type)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 19,
                      class: _normalizeClass({
                'up-color':
                  item.prop !== 'profit'
                    ? false
                    : !scope.row[item.prop].includes('-'),
                'down-color':
                  item.prop !== 'profit'
                    ? false
                    : scope.row[item.prop].includes('-'),
              })
                    }, _toDisplayString(scope.row[item.prop] ?? "--"), 3))
                  : _createCommentVNode("", true),
                (item.type === 'className')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 20,
                      class: _normalizeClass(item.class)
                    }, _toDisplayString(scope.row[item.prop] ?? "--"), 3))
                  : _createCommentVNode("", true),
                (item.type === 'render')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 21 }, [
                      _createTextVNode(_toDisplayString(item.render(scope.row[item.prop], scope.row, scope)), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (item.type === 'renderHTML')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 22,
                      "data-textSelect": item.textSelect,
                      style: _normalizeStyle(item.textSelect ? 'cursor:text;' : ''),
                      innerHTML: item.render(scope.row[item.prop], scope.row, scope)
                    }, null, 12, _hoisted_35))
                  : _createCommentVNode("", true),
                (item.type === 'setting')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findShowBtn(item.setting, scope.row), (set, sIdx) => {
                        return (_openBlock(), _createElementBlock("section", { key: sIdx }, [
                          _createVNode(_component_el_button, {
                            onClick: _withModifiers(($event: any) => (
                  _ctx.handleCommand(scope.$index, scope.row, set.btnType)
                ), ["stop"]),
                            class: _normalizeClass({ btnText: true, lineText: set.color === 'text' }),
                            disabled: set.disabled,
                            type: set.color || '',
                            round: set.round,
                            style: _normalizeStyle({
                  'background-color': set.bgColor,
                  color: set.colorStyle,
                  'text-decoration': 'none',
                  'font-size': '14px',
                  'z-index': '9999',
                }),
                            size: "mini"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(set.youName ? scope.row[set.youName] : set.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "class", "disabled", "type", "round", "style"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'slot')
                  ? _renderSlot(_ctx.$slots, item.prop, {
                      key: 24,
                      row: scope.row
                    }, undefined, true)
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["fixed", "prop", "label", "width", "align", "class", "style"]))
          }), 128))
        ]),
        _: 3
      }, 8, ["row-class-name", "stripe", "data", "height", "onRowClick", "cell-class-name"])), [
        [_directive_loading, _ctx.tableLoading]
      ]),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode(_component_tips_dialog, {
      tipsDialog: _ctx.cancelOrderDialog,
      "onUpdate:tipsDialog": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cancelOrderDialog) = $event)),
      title: "废单原因"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", null, _toDisplayString(_ctx.cancelOrderText), 1)
        ])
      ]),
      _: 1
    }, 8, ["tipsDialog"])
  ], 64))
}